import { SellerMassImport } from 'components/sellers/SellerMassImport/SellerMassImport'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { appSelectors } from 'store/app'

export const ProfileMassImport: React.FC = () => {
  const sellerId = useAppSelector(appSelectors.selectSellerId)
  return <SellerMassImport sellerId={sellerId ?? ''} />
}
